import React from 'react';

// Minimalist pelican logo - school symbol
// Designed with clean strokes matching the Notion/Medium aesthetic
export const PelicanLogo = ({ className = "h-6 w-6", strokeWidth = 1.5 }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="ArdNotes pelican logo"
    >
      {/* Pelican body */}
      <path
        d="M14 38 C 14 28, 22 20, 32 20 C 42 20, 50 28, 50 38 C 50 44, 46 48, 42 48 L 22 48 C 18 48, 14 44, 14 38 Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      {/* Pelican head */}
      <circle cx="44" cy="22" r="7" stroke="currentColor" strokeWidth={strokeWidth} fill="none" />
      {/* Pelican beak (long, characteristic) */}
      <path
        d="M50 22 L 60 24 L 56 28 L 50 26"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />
      {/* Pouch under beak */}
      <path
        d="M49 26 Q 52 32, 48 33"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
      />
      {/* Eye */}
      <circle cx="45" cy="21" r="1" fill="currentColor" />
      {/* Wing detail */}
      <path
        d="M22 32 Q 30 28, 38 34"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
      />
      {/* Leg */}
      <path
        d="M26 48 L 26 54 M 32 48 L 32 54"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      {/* Webbed feet */}
      <path
        d="M22 54 L 30 54 M 28 54 L 36 54"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};
